export default "__VITE_ASSET__Dvg4o0sq__"